module.exports = __webpack_public_path__ + "static/media/IF50_news_18-10-2022.69614dcf.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/IF50_news_18-10-2022.webp
// module id = 305
// module chunks = 0